<template>
	<section class="embed-frame">
		<iframe v-if="iframeLink" :key="iframeLink" :src="iframeLink" title="گزارش" frameborder="0" allowfullscreen></iframe>
		<EmptyState v-else-if="!loading" :kind="failed ? 'error' : 'generic'" :title="failed ? 'گزارش بارگذاری نشد' : 'گزارشی برای این بخش تعریف نشده'" description="">
			<button v-if="failed" type="button" class="btn btn-outline-primary" @click="load">تلاش دوباره</button>
		</EmptyState>
		<div v-else class="embed-loading" role="status" aria-label="در حال بارگذاری گزارش"></div>
	</section>
</template>
<script>
import EmptyState from '@/components/EmptyState/index.vue';

// A report is a menu record with an iframe link; /reports/:id carries the menu id.
export default {
	components: { EmptyState },
	data() {
		return { iframeLink: null, loading: true, failed: false };
	},
	watch: {
		'$route.params.id': { handler: 'load', immediate: true },
	},
	methods: {
		async load() {
			this.loading = true;
			this.failed = false;
			this.iframeLink = null;
			const res = await this.$ApiServiceLayer.get(
				this.$PATH.RELATIVE_PATH.MULTI.MENU_EDIT_LISTS + this.$route.params.id + '/?p=' + this.$STORE.state.userConfig.setProjectId,
				this.$PATH.SERVICE_NAME.AUTH,
			);
			if (res.status === 200) this.iframeLink = res.data.iframe_link || null;
			else this.failed = true;
			this.loading = false;
		},
	},
};
</script>
<style scoped>
.embed-frame { position: relative; height: calc(100vh - 190px); min-height: 480px; background: var(--surface); border: 1px solid var(--line); border-radius: var(--r-md); overflow: hidden; }
.embed-frame iframe { display: block; width: 100%; height: 100%; border: 0; }
.embed-loading { height: 100%; background: linear-gradient(90deg, var(--navy-50), var(--surface), var(--navy-50)); background-size: 200% 100%; animation: shimmer 1.4s linear infinite; }
@keyframes shimmer { to { background-position: -200% 0; } }
</style>
